interface SiteConfiguration {
    isDev: boolean;
}

export default function useConfiguration(): SiteConfiguration {
    return {
        isDev: process.env.NODE_ENV !== 'production'
    };
}